<div id="overlay"> 
        <div class="overlay-message"></div>
</div>
<!-- <div *ngIf="formError" tabindex="-1" id="error" class="error-message">{{formError}}</div> -->
<!-- *ngIf="searchOrderAccess" -->
<div  fxGrow=false class="mat-elevation-z1" style="padding:12px; margin-bottom: 16px" fxLayout="row" fxLayoutAlign="start center"
    fxLayoutGap="8px">
    <div id="searchBox" style="padding:6px; border: 1px solid #e9e9e9;" fxFlex fxGrow fxLayoutAlign="start center">
        <mat-icon color="accent" style="margin-right:4px;">{{configData.imageIcon}}</mat-icon>
        <input fxFlex type="text" [(ngModel)]="searchBoxVal" [placeholder]="configData.placeHolder" style="border: 0;" autocomplete="off" (keyup)="getSearchResultData($event, {})">
        <mat-icon *ngIf="showDownArrow && configData.filter === 'true'" style="cursor:pointer" matTooltip="{{configData.tooltipText}}" (click)="openDialog()">arrow_drop_down</mat-icon>        
    </div>    
    <!-- <div *ngIf="configData.action" class="remove-margin">
        <div fxGrow="false" fxShrink="false">
            <button *ngIf="createOrderAccess" type="{{configData.action.type}}" color="warn" mat-stroked-button class="dhl-button" (click)="navigateUrl(configData.action.command.url)" matTooltip="{{configData.action.toolTip}}">            
                <mat-icon>
                    {{configData.action.icon}}
                </mat-icon>
                <span class="action-name">{{configData.action.name}}</span>
            </button>
        </div>  
    </div>
    <div *ngIf="configData.action1 && releaseOrderAccess"  class="add-margin">
        <div fxGrow="false" fxShrink="false">
            <button type="{{configData.action1.type}}" color="warn" mat-stroked-button class="dhl-button" (click)="navigateUrl(configData.action1.command.url)" matTooltip="{{configData.action1.toolTip}}">
                <mat-icon>
                    {{configData.action1.icon}}
                </mat-icon>
                <span class="action-name">{{configData.action1.name}}</span>
            </button>
        </div>      
    </div>     -->
    <ng-container *ngIf="configData.actions && configData.actions['length']">
        <ng-container *ngFor="let action of configData.actions;let index = index;">
            <!-- [ngClass]="index == 1 ? 'add-margin': 'remove-margin'" -->
            <div *ngIf="checkHasPermission(action.permission, action.command.type)" >
                <div fxGrow="false" fxShrink="false">
                    <!-- createOrderAccess -->
                    <button  type="{{action.type}}" [disabled]="action.disabled" color="warn" mat-stroked-button class="dhl-button" (click)="navigateUrl(action, action.command.type)" matTooltip="{{action.toolTip}}">
                        <mat-icon>
                            {{action.icon}}
                        </mat-icon>
                        <span class="action-name">{{action.label}}</span>
                    </button>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>

<div [hidden]="!showHide" *ngIf="configData.filter === 'true'">
    <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing" style="background-color: transparent;" (click)="hideForm()"></div>    
    <div class="cdk-global-overlay-wrapper" dir="ltr">
        <div id="cdk-overlay-4" class="cdk-overlay-pane">
            <div style="display: block" class="dialog-box mat-elevation-z2" id="filter-form">                 
                <app-app-order-filter (filterData)="getFilterData($event)" (filterModal)="getFilterModal($event)" [configData]="configData" [frmGroup]="frmGroup"></app-app-order-filter>                        
            </div>
        </div>
    </div>    
</div>    

<app-form-table-list (errorMessage)="checkError($event)" [searchMessage]="searchMessage" [searchData]="searchList" [configData]="configData" [pageNumSearch]="pageNumber" (clearFilter)="getFilterData($event)"></app-form-table-list>
<app-progress-spinner-v2 *ngIf="isLoading"></app-progress-spinner-v2>
